import React, {Component} from 'react';
import './ApiReference.css';
import {HashRouter} from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';

export default class ApiReference extends Component {

    render() {
        return (
            <HashRouter>
            <div className="Api">
                <div className="container">
                    <div className="Api_block">
                        <h1>API REFERENCE</h1>
                        <p>
                            Thanks to the site <a href="http://numbersapi.com">http://numbersapi.com</a> for providing
                            API
                        </p>
                        <p>
                            And also thanks to <a href="https://rapidapi.com/divad12/api/numbers-1">https://rapidapi.com/divad12/api/numbers-1</a> for https for the ability to download the project to Github
                        </p>
                    </div>

                    <div className="Api_block">
                        <h1>URL STRUCTURE</h1>
                        <p>
                            Thanks to the site "http://numbersapi.com" for providing API
                        </p>
                        <p>
                            Just hit <span><a href="http://numbersapi.com/">http://numbersapi.com/</a><b>number/type</b></span> to
                            get a plain text response, where
                        </p>

                        <div>
                            <ul>
                                <li><span className="bgColor fw700">type</span> is one of <span
                                    className="bgColor italic">trivia</span>, <span
                                    className="bgColor italic">math</span>, <span className="bgColor italic">date</span>,
                                    or <span className="bgColor italic">year</span>. Defaults to trivia if omitted.
                                </li>
                                <li><span className="bgColor fw700">number</span> is</li>
                                <ul>
                                    <li>an integer, or</li>
                                    <li>the keyword <span className="bgColor italic">random</span>, for which we will
                                        try to return a random available fact, or
                                    </li>
                                    <li>a day of year in the form <span
                                        className="bgColor fw700">month/day</span>(eg. <span
                                        className="bgColor">2/29</span>, <span className="bgColor">1/09</span>, <span
                                        className="bgColor">04/1</span>), if type is date
                                    </li>
                                    <li><Link to="Api-reference#batching">ranges of numbers</Link></li>
                                </ul>
                            </ul>
                        </div>

                        <div className="Api_elem">
                            <p>http://numbersapi.com/42<br/>
                                ⇒ 42 is the result given by Google and Bing for the query "the answer to life the
                                universe and everything".</p>

                            <p>http://numbersapi.com/2/29/date<br/>
                                ⇒ February 29 is the day in 1504 that Christopher Columbus uses his knowledge of a lunar
                                eclipse to convince Native Americans to provide him with supplies.</p>

                            <p>http://numbersapi.com/random/year<br/>
                                ⇒ 2013 is the year that China will attempt its first unmanned Moon landing.</p>
                        </div>
                    </div>

                    <div className="Api_block">
                        <h1>USAGE EXAMPLES</h1>
                        <h3>JQUERY</h3>

                        <h4>HTML:</h4>
                        <div className="Api_elem">
                            <p> We now have more users than &lt;span id="number"&gt;&lt;/span&gt;!</p>
                        </div>

                        <h4> JavaScript:</h4>
                        <div className="Api_elem">
<pre><code>$.get('http://numbersapi.com/1337/trivia?notfound=floor&fragment', function(data) {
    "$('#number').text(data);"
});</code></pre>
                        </div>

                        <p>Direct cross-origin requests like this are possible on browsers that support <a
                            href="https://en.wikipedia.org/wiki/Cross-origin_resource_sharing"> CORS</a>. Live demo
                            on <a href="http://jsfiddle.net/divad12/ffHEh/">JSFiddle</a>.</p>

                        <h3 id="JSONP">JSONP</h3>
                        <p>...is supported with the query field<Link to="Api-reference#callback"><span
                            className="bgColor">callback:</span></Link></p>

                        <div className="Api_elem">
<pre><code>&lt;span id="number-fact"&gt;&lt;/span&gt;

    &lt;script&gt;
    function showNumber(str) {
        "document.getElementById('number-fact').innerText = str;"
    }

    (function() {
        `var scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = "http://numbersapi.com/42/math?callback=showNumber";
        document.body.appendChild(scriptTag);`
    })();
    &lt;/script&gt;</code></pre>
                        </div>

                        <p>Live demo on <a href="http://jsfiddle.net/divad12/4A6Pw/"><span
                            className="bgColor">JSFiddle</span>.</a></p>

                        <h3 id="HTML-EMBED">HTML EMBED</h3>
                        <p>Add <span className="bgColor">write</span> to your query string to have the response text
                            wrapped in <span className="bgColor">document.write().</span> Now you can stick just a
                            single <span className="bgColor">&lt;script&gt;</span> directly where the fact should go.
                        </p>


                        <div className="Api_elem">
                            <p>Did you know 2012 is the year that &lt;script
                                src="http://numbersapi.com/2012/year?write&fragment"&gt;&lt;/script&gt;</p>
                        </div>

                        <p>Note that this may <a href="https://developer.yahoo.com/performance/rules.html#js_bottom">degrade
                            page load speed</a>. Live demo on <a href="http://jsfiddle.net/divad12/4A6Pw/">JSFiddle</a>.
                        </p>
                    </div>

                    <div className="Api_block">
                        <h1>QUERY PARAMETER OPTIONS</h1>
                        <h3>FRAGMENT</h3>
                        <p>
                            Return the fact as a sentence fragment that can be easily included as part of a larger
                            sentence. This means that the first word is lowercase and ending punctuation is omitted. For
                            trivia and math, a noun phrase is returned that can be used in a sentence like "We now have
                            more users than [fact as fragment]!".
                        </p>

                        <div className="Api_elem">
                            <p>http://numbersapi.com/23/trivia?fragment<br/>
                                ⇒ the number of times Julius Caesar was stabbed<br/>
                                <br/>
                                    http://numbersapi.com/1969/year?fragment<br/>
                                    ⇒ an estimated 500 million people worldwide watch Neil Armstrong take his historic
                                    first steps on the Moon</p>
                        </div>

                        <h3>NOTFOUND</h3>
                        <p>The <span className="bgColor">notfound</span> field tells us what to do if the number is not
                            found. You can give us</p>
                        <ul>
                            <li>
                                <p><span className="bgColor">default</span> to return one of our pre-written missing
                                    messages, or a message you supply with the <span className="bgColor"><Link to="Api-reference#default">default</Link></span> query field. This is the default behaviour.
                                </p>
                                <div className="Api_elem">
                                    <p>http://numbersapi.com/314159265358979<br/>
                                        ⇒ 314159265358979 is a boring number.</p>
                                </div>
                            </li>

                            <li>
                                <p><span className="bgColor">floor</span> to round down to the largest number that does
                                    have an associated fact, and return that fact.</p>
                                <div className="Api_elem">
                                    <p>http://numbersapi.com/35353?notfound=floor<br/>
                                        ⇒ 35000 is the number of genes in a human being.</p>
                                </div>
                            </li>

                            <li>
                                <p><span className="bgColor">ceil</span>, which is like <span
                                    className="bgColor">floor</span> but rounds up to the smallest number that has an a
                                </p>
                                <div className="Api_elem">
                                    <p>http://numbersapi.com/35353?notfound=floor<br/>
                                        ⇒ 35000 is the number of genes in a human being.</p>
                                </div>
                            </li>
                        </ul>

                        <p>Combine with the <Link to="Api-reference#fragment">fragment</Link> option to produce interesting facts about,
                            for example, <Link to="Api-reference#visitors">the number of page shares</Link>.</p>

                        <h3 id="default">DEFAULT</h3>
                        <p>The value of the `default` query field tells us what to return if we don't have a fact for
                            the requested number.</p>

                        <div className="Api_elem">
                            <p>http://numbersapi.com/1234567890987654321/year?default=Boring+number+is+boring.<br/>
                                ⇒ Boring number is boring.</p>
                        </div>

                        <h3 id="callback">CALLBACK</h3>
                        <p>To use [JSONP](http://en.wikipedia.org/wiki/JSONP), pass to the `callback` query the name of
                            the JavaScript function to be invoked. The response will be that function called on the fact
                            text as a string literal.</p>
                        <div className="Api_elem">
                            <p>http://numbersapi.com/42/math?callback=showNumber<br/>
                                ⇒ showNumber("42 is the 5th Catalan number.")</p>
                        </div>
                        <p>See the <Link to="Api-reference#JSONP">JSONP usage example</Link>.</p>


                        <h3 id="callback">WRITE</h3>
                        <p>Returns the text response wrapped in a call to
                            [`document.write()`](https://developer.mozilla.org/en/document.write). Note that using this
                            query parameter is equivalent to and just a shorthand of `?callback=document.write`.</p>
                        <div className="Api_elem">
                            <p>http://numbersapi.com/42/math?write<br/>
                                ⇒ document.write("42 is the 5th Catalan number.");</p>
                        </div>
                        <p>See the <Link to="Api-reference#HTML-EMBED">HTML embed tag usage example</Link>.</p>


                        <h3 id="callback">MIN AND MAX</h3>
                        <p>Restrict the range of values returned to the inclusive range [<span
                            className="bgColor fw700">min</span>, <span className="bgColor fw700">max</span>] when <span
                            className="bgColor fw700">random</span> is given as the number.</p>
                        <div className="Api_elem">
                            <p>http://numbersapi.com/random?min=10&max=20<br/>
                                13 is the number of provinces and territories in Canada.</p>
                        </div>


                        <h3 id="JSON">JSON</h3>
                        <p>Include the query parameter `json` or set the HTTP header `Content-Type` to
                            `application/json` to return the fact and associated meta-data as a JSON object, with the
                            properties:</p>
                        <ul>
                            <li>
                                <span className="bgColor">text</span>: A string of the fact text itself.
                            </li>
                            <li>
                                <span className="bgColor">found</span>: Boolean of whether there was a fact for the
                                requested number.
                            </li>
                            <li>
                                <span className="bgColor">number</span>: The floating-point number that the fact
                                pertains to. This may be useful for, eg. a <span
                                className="bgColor">/random</span> request or <span className="bgColor">notfound=floor
                            </span>
                            . For a date fact, this is the 1-indexed day of a leap year (eg. 61 would be March 1st).
                        </li>
                        <li>
                            <span className="bgColor">type</span>: String of the category of the returned fact.
                        </li>
                        <li>
                            <span className="bgColor">date</span> (sometimes): A day of year associated with some year
                            facts, as a string.
                        </li>
                        <li>
                            <span className="bgColor">year</span> (sometimes): A year associated with some date facts,
                            as a string.
                        </li>
                    </ul>
                    <div className="Api_elem">
<pre><code>http://numbersapi.com/random/year?json
   ⇒ {
        "text: 2012 is the year that the century's second and last solar transit of Venus occurs on June 6.," +
        "found: true," +
        "number: 2012," +
        "type: year," +
        "date: June 6"
    }</code></pre>
</div>

</div>


    <div className="Api_block">
        <h1 id={'batching'}>BATCH REQUESTS</h1>
        <p>
            To get facts about multiple <span className="bgColor fw700">numbers</span> in one request, specify ranges
            for number in:<br/>
        </p>
        <p>
            <span className="bgColor">
                <a href="http://numbersapi.com">http://numbersapi.com</a>
            </span>
            <span className="fw700">/number/type</span>.
        </p>

        <p>A number range (inclusive) is specified as <span className="bgColor fw700">min..max</span>. Separate multiple
            ranges and individual numbers with <span className="bgColor fw700">,</span> (a comma).</p>

        <p>The response format will always be a JSON map from numbers to facts, of at most 100 numbers. The query
            parameter <span className="bgColor"><Link to="Api-reference#JSON">json</Link></span> may still be used to specify whether
            individual facts will be returned as string literals or JSON objects.</p>

        <div className="Api_elem">
<pre><code>http://numbersapi.com/1..3,10  <br/> +
⇒ {<br/> +
        "1: 1 is the number of dimensions of a line.," + <br/> +
        "2: 2 is the number of polynucleotide strands in a DNA double helix.," +  <br/> +
        "3: 3 is the number of sets needed to be won to win the whole match in volleyball.," +  <br/> +
        "10 is the highest score possible in Olympics gymnastics competitions."
    }</code></pre>
</div>
</div>

</div>
    </div>
            </HashRouter>
        );
    }
}
